import script from "./DropdownClientes.vue?vue&type=script&setup=true&lang=ts"
export * from "./DropdownClientes.vue?vue&type=script&setup=true&lang=ts"

import "./DropdownClientes.vue?vue&type=style&index=0&id=6770a6f6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6770a6f6"]])

export default __exports__